MoyaComponents.register('banner.sticky', (el) => {
	const text = document.querySelector(".sticky__banner__description p");
	let textdivs = document.querySelector(".sticky__banner__description");
	const lineMaxLen = 25;
	const wsLookup = 15;
	const regex = new RegExp(String.raw`\s*(?:(\S{${lineMaxLen}})|([\s\S]{${lineMaxLen - wsLookup},${lineMaxLen}})(?!\S))`, 'g');
	textdivs.innerHTML = text.textContent.replace(regex, (_, x, y) => x ? `<div>${x}-</div>` : `<div>${y}</div>`);

	function observerCallback(entries, observer) {
		entries.forEach(entry => {
			entry.target.style.opacity = entry.intersectionRatio
		});
	}
	let options = {
		root: null,
		rootMargin: "-25% 0px -25% 0px",
		threshold: [0,0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,1]
	}
	let observer = new IntersectionObserver(observerCallback, options);

	const div = document.querySelectorAll('.sticky__banner__description div');
	div.forEach(el => observer.observe(el));

});
